import * as Yup from "yup";

// Helper function to remove HTML tags and check meaningful text
const isMeaningfulText = (value?: string) => {
  if (!value) return false; // Handle undefined or empty values
  const strippedText = value.replace(/<\/?[^>]+(>|$)/g, "").trim();
  return strippedText.length > 0;
};

const vacancyTextSchema = Yup.object().shape({
  professional: Yup.string()
    .test("meaningful-text", "Professional & Formal is required", (value) =>
      isMeaningfulText(value)
    )
    .required("Professional & Formal is required"),

  neutral: Yup.string()
    .test("meaningful-text", "Neutral & Clear is required", (value) =>
      isMeaningfulText(value)
    )
    .required("Neutral & Clear is required"),

  engaging: Yup.string()
    .test("meaningful-text", "Engaging & Conversational is required", (value) =>
      isMeaningfulText(value)
    )
    .required("Engaging & Conversational is required"),
});

export default vacancyTextSchema;
